module.exports = __webpack_public_path__ + "static/media/3DPPA37.86dd00ea.jpg";